export class SeccionBlog {
    public subtitulo: string;
    public tipoSeccion: string; //texto, imagen
}
